import SelectBox, { ISelectBoxOptions } from "devextreme-react/select-box";
import BaseControlProps from "interfaces/BaseControlProps";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import {
  getSizeSpecificClasses,
  getControlRadius,
} from "shared/utility/ControlUtility";
import "./styles/Controls.css";

export default function Select(props: ISelectBoxOptions & BaseControlProps) {
  const { className, ...rest } = props;
  const { size, radiusSize } = props;

  const getClassNames = () => {
    const defaultClassNames = `prom-select ${getSizeSpecificClasses(
      size
    )} ${getControlRadius(
      radiusSize
    )} border-1.5 border-primaryRed outline-none text-primaryRed`;
    return className ? `${defaultClassNames} ${className}` : defaultClassNames;
  };

  const DropdownButton = () => {
    return (
      <div className="icon dx-icon-chevrondown text-primaryRed mt-2"></div>
    );
  };

  return (
    <SelectBox
      dropDownButtonRender={DropdownButton}
      className={getClassNames()}
      {...rest}
    />
  );
}

Select.defaultProps = {
  size: ControlSize.Midium,
  radiusSize: ControlSize.Large,
};
